import { convertFile, File, Id, RepositoryResponse } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useChatGroupMedia(conversationId: Id, enabled = true) {
  const { server } = useServer()
  return useQuery<File[]>({
    queryKey: keys.media(conversationId),
    queryFn: fetchChatGroupMedia,
    enabled,
  })

  async function fetchChatGroupMedia(): Promise<File[]> {
    const response = await server.get<RepositoryResponse.File[]>(
      `/v2/chat/repository/${conversationId}/media`
    )
    return await Promise.all(response.map(convertFile))
  }
}
